import { render } from "./WorkspaceManagedScripts.vue?vue&type=template&id=5d42dc74&scoped=true"
import script from "./WorkspaceManagedScripts.vue?vue&type=script&lang=js"
export * from "./WorkspaceManagedScripts.vue?vue&type=script&lang=js"

import "./WorkspaceManagedScripts.vue?vue&type=style&index=0&id=5d42dc74&scoped=true&lang=css"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d42dc74"]])

export default __exports__